import React, {Component} from 'react';
import Button from '../../../../shared/library/Button/Button';
import LeadForm from '../../../../shared/LeadForm';
import styles from './css/EmailLeadForm.styl';
import {
  buildSalesforcePayload,
  sendToWebcollect,
} from '../../../../../appModules/utilities/salesforceApi';
import {GUIDE_LINK} from '../../../../shared/PlanningGuideLeadForm';

class TempLeadForm extends Component {
  fields = [
    {
      name: 'email',
      title: 'Email Address',
      placeholder: 'Enter your Email Address',
      type: 'email',
    },
  ];

  styles = {
    width: '100%',
    maxWidth: '485px',
    margin: '0 auto',
  };

  handleSubmit = (formValues, formik) => {
    const body = buildSalesforcePayload({
      form: 'helpPlanning',
      formValues,
    });

    sendToWebcollect({
      body,
      externalKey: 'ECC651A8-1542-47A9-83A5-98E1CFDC788E',
    })
      .then(json => {
        const {success, error = undefined} = json; // eslint-disable-line no-undefined

        formik.setSubmitting(false);
        formik.setStatus({
          loading: false,
          success,
          error,
        });
      })
      .catch(() => {
        formik.setSubmitting(false);
        formik.setStatus({
          loading: false,
          error: true,
          success: false,
        });
      });
  };

  renderSuccess = () => {
    return (
      <div className={styles.SuccessContainer}>
        <p className={styles.SuccessMessage}>Success! Thank you.</p>
        <Button
          href={GUIDE_LINK}
          type="large-button"
          className={styles.SuccessButton}
          target="_blank"
          download="Your Guide to Planning Ahead"
        >
          Download Your Guide
        </Button>
      </div>
    );
  };

  render() {
    return (
      <div style={this.styles} className={styles.EmailLead}>
        <LeadForm
          initialValues={{email: ''}}
          onSubmit={this.handleSubmit}
          submitText="Get the Guide"
          renderSuccess={this.renderSuccess}
          fields={this.fields}
          styleMods={{emailOnly: true}}
        />
      </div>
    );
  }
}

export default TempLeadForm;



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/LeadFormEmailOnly/index.js